import React from 'react';
import CopyableSnippet from '../../components/utils/CopyableSnippet';

const Layout = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Layout</h1>
    </div>
    <div className="page-content">
      <div className="component-example__sub-example">
        <p className="component-example__grey-bg padding-xs clearfix">
          <div className="margin-xs padding-lg bg-white pull-left center-block" style={{ width: 180 }}>
            <CopyableSnippet code="pull-left" />
          </div>
        </p>
        <p className="component-example__grey-bg padding-xs clearfix">
          <div
            className="margin-top-xs margin-bottom-xs padding-lg bg-white text-center center-block"
            style={{ width: 220 }}
          >
            <CopyableSnippet code="center-block" />
          </div>
        </p>
        <p className="component-example__grey-bg padding-xs clearfix">
          <div className="margin-xs padding-lg bg-white pull-right center-block" style={{ width: 180 }}>
            <CopyableSnippet code="pull-right" />
          </div>
        </p>
        <p className="component-example__grey-bg padding-xs l-position-context">
          <div className="margin-xs padding-lg">
            <CopyableSnippet code="l-position-context" />
          </div>
        </p>
        <p className="component-example__grey-bg padding-sm">
          <div className="l-position-context" style={{ height: 100 }}>
            <div className="bg-white l-cover l-flex-hcenter l-flex-vcenter">
              <CopyableSnippet code="l-cover" />
            </div>
          </div>
        </p>
        <p className="component-example__grey-bg padding-sm l-position-context" style={{ height: 200 }}>
          <div className="padding-lg bg-white l-pos-center">
            <CopyableSnippet code="l-pos-center" />
          </div>
        </p>
      </div>
    </div>
  </React.Fragment>
);

export default Layout;